/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

export default {
  "Switch language": "Switch language",
  "Botanical garden of the Charles University Science Faculty":
    "Botanical garden of the Charles University Science Faculty",
  "Visit us": "Visit us",
  Events: "Events",
  "Garden map": "Garden map",
  Expositions: "Expositions",
  Tours: "Tours",
  Other: "Other",
  Contacts: "Contacts",
  Search: "Search",
  open: "open",
  closed: "closed",
  "Today {open}": "Today {open}",
  "Search for...": "Search for...",
  BGUK: "BGUK",
  "Today we're": "Today we're",
  "When we're open": "When we're open",
  published: "published"
};
